import { ClientInformationInterface, ClientInformationSources } from "../interfaces/client-data";

export module IntegrationSourceHelper {
    export function setupSources(clientModel: ClientInformationInterface): ClientInformationSources {
        let clientInfo: ClientInformationSources;
        clientInfo = {
            primaryEmployeeSource: IntegrationSourceHelper.getPrimaryEmployeeSource(clientModel),
            primaryBranchSource: IntegrationSourceHelper.getPrimaryBranchSource(clientModel),
            technicalEmail: IntegrationSourceHelper.getTechnicalContactEmail(clientModel),
            primaryEmail: IntegrationSourceHelper.getPrimaryContactEmail(clientModel),
            idHmdaLEI: IntegrationSourceHelper.getHmdaLeiId(clientModel),
            idNMLS: IntegrationSourceHelper.getNmlsId(clientModel),
            idAnalytics: IntegrationSourceHelper.getIdAnalytics(clientModel),
        }
        return clientInfo;
    }

    export function getPrimaryEmployeeSource(clientModel: ClientInformationInterface): string {
        var result = clientModel.clientIntegrationSources?.find(
            (s) => s.isPrimaryForEmployeeIdentifier
        )?.description;
        if(result) {
            return result;
        } else {
            return "";
        }
    }

    export function getPrimaryBranchSource(clientModel: ClientInformationInterface): string {
        var result = clientModel.clientIntegrationSources?.find(
            (s) => s.isPrimaryForBranchIdentifier
        )?.description;
        if(result) {
            return result;
        } else {
            return "";
        }
    }

    export function getTechnicalContactEmail(clientModel: ClientInformationInterface): string {
        var result = clientModel.contacts?.find(
            (contact) => contact.contactTypeAbbr === 'Technical'
        )?.contactValue;
        if(result) {
            return result;
        } else {
            return "";
        }
    }

    export function getPrimaryContactEmail(clientModel: ClientInformationInterface): string {
        var result = clientModel.contacts?.find(
            (contact) => contact.contactTypeAbbr === 'Primary'
        )?.contactValue;
        if(result) {
            return result;
        } else {
            return "";
        }
    }

    export function getHmdaLeiId(clientModel: ClientInformationInterface): string {
        var result = clientModel.identifiers?.find((id) => id.identifierType === 'LEI')?.identifier;
        if(result) {
            return result;
        } else {
            return "";
        }
    }

    export function getNmlsId(clientModel: ClientInformationInterface): string {
        var result = clientModel.identifiers?.find((id) => id.identifierType === 'NMLS')?.identifier;
        if(result) {
            return result;
        } else {
            return "";
        }
    }
    
    export function getIdAnalytics(clientModel: ClientInformationInterface) {
        var result = clientModel.identifiers?.find((id) => id.identifierType === 'IdAnalytics')?.identifier;
        if(result) {
            return result;
        } else {
            return "";
        }
    }
}
